import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import uploadIcon from "../../assets/svg/upload-icon.svg";
import downloadIcon from "../../assets/svg/download-icon.svg";
import templateIcon from "../../assets/svg/template-icon.svg";
import {
  downloadExcelApi,
  uploadExcelApi,
  downloadTemplateExcelApi,
} from "../masters/master-api";
import { downloadBase64File, downloadReportFile } from "../report/report-api";

const CustomerButtons = ({
  activeTab,
  responseMsg,
  isTemplate,
  isUpload,
  isDownload,
}) => {
  const tabs = [
    {
      template: "gate_master",
      upload_url: "master_import/gate_master",
      download_url: "master_report/gate_master?from_date&to_date",
      key: "gate",
    },
    {
      template: "checklist",
      upload_url: "master_import/checklist",
      download_url: "master_report/checklist?from_date&to_date",
      key: "checklist",
    },
    {
      label: "Vehicle Type",
      template: "vehicle_type",
      upload_url: "master_import/vehicle_type",
      download_url: "master_report/vehicle_type?from_date&to_date",
      key: "vehicle",
    },
    {
      label: "Customer",
      template: "customer",
      upload_url: "master_import/customer",
      download_url: "master_report/customers?from_date&to_date",
      key: "customer",
    },
    {
      label: "Transporters",
      template: "transporter",
      upload_url: "master_import/transporter",
      download_url: "master_report/transporters?from_date&to_date",
      key: "transporter",
    },
    {
      label: "Vendors",
      template: "vendor",
      upload_url: "master_import/vendor",
      download_url: "master_report/vendors?from_date&to_date",
      key: "vendor",
    },
    {
      label: "Product Type",
      template: "product_type",
      upload_url: "master_import/product_type",
      download_url: "master_report/product_types?from_date&to_date",
      key: "product",
    },
    {
      template: "purpose_of_visit",
      upload_url: "master_import/purpose_of_visit",
      download_url: "master_report/purpose_of_visit?from_date&to_date",
      key: "purpose_of_visit",
    },
    /*  {
      label: "Auto Report Trigger",
      template: "",
      download_url: "master_report/auto_mail_triggers?from_date&to_date",
      key: "autotrigger",
    },
    {
      template: "register",
      upload_url: "master_import/register",
      download_url: "master_report/register?from_date&to_date",
      key: "register",
    },
    {
      label: "Alert Configurations",
      to: "/alertconfigurations",
      key: "alertconfigurations",
    },
    { label: "Register Fields", to: "/registerfields", key: "registerfields" }, */
  ];
  const [isUploading, setIsUploading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadExcel = async (responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsDownloading(true);
      const response = await downloadExcelApi(tabs[index].download_url);
      setIsDownloading(false);

      if (response.status === 200) {
        if (response.data.success === true) {
          await downloadReportFile(response.data, tabs[index].template || activeTab);
          responseMsg(response.data);
        }
      }
    }
  };
  const fileInputRef = useRef(null);
  const handleFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("File input is not initialized.");
    }
  };
  const handleFileChange = (event, responseMsg) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result; // this will be the byte code (base64String)

        uploadExcel(base64String, responseMsg);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select a valid excel file.");
    }
    fileInputRef.current.value = "";
  };
  const uploadExcel = async (base64String, responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      try {
        setIsUploading(true);
        const response = await uploadExcelApi(
          tabs[index].upload_url,
          base64String
        );
        setIsUploading(false);
        if (response && response.status === 200) {
          if (response.data?.success === true) {
            await downloadReportFile(response.data, tabs[index].template || activeTab);
          }
          if (responseMsg && response.data) {
            responseMsg(response.data);
          }
        } else {
          if (responseMsg && response?.data) {
            responseMsg(response.data);
          }

          if (response?.data) {
            await downloadReportFile(response.data, activeTab + "_" + new Date().getTime());
          }
        }
      } catch (err) {
        setIsUploading(false);
        console.error("Upload error:", err);
        if (responseMsg) {
          responseMsg({
            success: false,
            message: err?.response?.data?.message || "File upload failed",
          });
        }
      }
    }
  };

  const downloadTemplateExcel = async (responseMsg) => {
    const index = tabs.findIndex((item) => item.key === activeTab);
    if (index > -1) {
      setIsDownloading(true);
      const response = await downloadTemplateExcelApi(tabs[index].template);
      setIsDownloading(false);
      if (response.status === 200) {
        if (response.data.success === true) {
          /* responseMsg(response.data); */
          await downloadReportFile(response.data, activeTab + "_template_" + new Date().getTime());
        }
      }
    }
  };
  return (
    <div>
      {tabs.findIndex((item) => item.key === activeTab) > -1 && (
        <div className="style-justify-start">
          {isUpload && (
            <>
              <button
                className="me-2"
                onClick={
                  isUploading === false
                    ? () => {
                        handleFileClick();
                      }
                    : null
                }
                style={{
                  background: "none",
                  border: "0.6px solid #DCDFE4",
                  borderRadius: "12px",
                  padding: "10px 8px",
                  height: "36px",
                  /* width: "40px", */
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  opacity: isUploading ? 0.6 : 1,
                }}
              >
                <img
                  src={uploadIcon}
                  alt="upload"
                  style={{ width: "14px", height: "14px" }}
                />
                <span
                  className="ps-1"
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#172B4D",
                  }}
                >
                  Upload
                </span>
              </button>
              <input
                ref={fileInputRef}
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={(event) => {
                  handleFileChange(event, responseMsg);
                }}
                style={{ display: "none" }} // Hide the actual file input
              />
            </>
          )}
          {isDownload && (
            <button
              onClick={
                isDownloading === false
                  ? () => {
                      downloadExcel(responseMsg);
                    }
                  : null
              }
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "10px 8px",
                height: "36px",
                /* width: "40px", */
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isDownloading ? 0.6 : 1,
              }}
            >
              <img
                src={downloadIcon}
                alt="download"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-1"
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#172B4D",
                }}
              >
                Download
              </span>
            </button>
          )}
          {isTemplate && (
            <button
              onClick={() => {
                downloadTemplateExcel(responseMsg);
              }}
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "10px 8px",
                height: "36px",
                /* width: "40px", */
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={templateIcon}
                alt="template"
                style={{ width: "14px", height: "14px" }}
              />
              <span
                className="ps-1"
                style={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#172B4D",
                }}
              >
                Template
              </span>
            </button>
          )}
        </div>
      )}
      {/* {tabs.map(({ label, to, key }) => (
                <Link
                    key={key}
                    to={to}
                    className={`customer-tab ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                >
                    {label}
                </Link>
            ))} */}
    </div>
  );
};

export default CustomerButtons;
